define(
    'views/topic_selector.view',[
        'loader',
        'config',
        'helper',
        'sandbox',

        'text!templates/topic_selector.html',
        'text!templates/messages_selector.html'
    ],
    function(Loader, Config, Helper, Sandbox, selectAllTopicsTemplate, selectAllMessagesTemplate)
    {
        var $ = Loader.$;
        var _ = Loader._;

        var TopicSelectorView = Loader.Backbone.View.extend(
            {
                events: Helper.prepareEventsForDevice(
                    {
                        'click #topic-selector': 'selectTopics',
                        'click #messages-selector': 'selectMessages'
                    },
                    Loader.eventType
                ),

                routes: {
                    "/moderate.php[?]fid": "appendSelector",
                    "/moderate.php[?]fid=(.*)&mode=": "appendMessagesSelector"
                },

                initialize: function()
                {
                    var _this = this;

                    this.model.on('startApplication', function(){
                        Helper.filterRoutes(_this.routes, _this);
                    });
                },

                appendSelector: function()
                {
                    var compiledTemplate = _.template(
                        selectAllTopicsTemplate,
                        {
                            model: this.model.toJSON()
                        }
                    );

                    this.$el.find('div.forum th.tcmod').html(compiledTemplate);
                },

                appendMessagesSelector: function()
                {
                    var compiledTemplate = _.template(
                        selectAllMessagesTemplate,
                        {
                            model: this.model.toJSON()
                        }
                    );

                    this.$el.find('div.modmenu p strong').after(compiledTemplate);
                },

                selectTopics: function(e)
                {
                    $(':checkbox:not(#topic-selector)', this.$el).trigger('click');
                },

                selectMessages: function(e)
                {
                    $(':checkbox:not(#messages-selector)', this.$el).trigger('click');
                }
            });

        return {
            initialize: function(model)
            {
                return new TopicSelectorView({
                    el: $("div#pun-main"),
                    model: model
                })
            }
        }
    }
);
